import { Adapter } from '@fmnts/core';
import { IApiPresentation } from '../api-model/campaign.api';
import { Presentation } from '../model/presentation';

export class ApiPresentationAdapter implements Adapter<Presentation> {
  adapt(item: IApiPresentation): Presentation {
    return new Presentation({
      id: item.refid,
      title: item.title,
      subtitle: item.subtitle,
      titleImage: item.title_image ?? null,
      documentHtml: item.document_html,
      inactiveTreshold: item.inactive_threshold,
    });
  }
}
